import GiftListPanel from "./giftListPanel.container";

export default GiftListPanel;
